import { Optional } from '../../../../Common/interfaces';
import { updateAt } from '../../../../Common/Utils';

export type Rating = { name: string; rating: number };

export function parseRatings(json: Optional<string>): Rating[] {
    return JSON.parse(json ?? '[]');
}

export function stringifyRatings(ratings: Rating[]): string {
    return JSON.stringify(ratings);
}

export function updateRating(
    ratings: Rating[],
    rating: Rating,
    value: number,
): Rating[] {
    const idx = ratings.findIndex((x) => x.name === rating.name);
    return updateAt(ratings, idx, { ...rating, rating: value });
}

export function hydrateRatings(ratings: Rating[], items: string[]): Rating[] {
    return items
        .map((x) => ({
            name: x,
            rating: ratings.find((y) => y.name === x)?.rating ?? 2,
        }))
        .sort((a, b) => (a.name < b.name ? -1 : 1));
}
